import { SEPARATOR } from '@hakimo-ui/hakimo/data-access';
import { Selectable } from '@hakimo-ui/shared/ui-base';

export const REFETCH_INTERVAL = 30000;

export function getLatestAlarmSearchParams(tenants?: Selectable[]): string {
  const params = new URLSearchParams();
  params.append('page', '1');
  params.append('pageSize', '1');
  params.append('relativeTimeHours', '1');
  params.append('isLatestTimestampCall', '1');

  if (tenants) {
    params.append('tenants', tenants.map((item) => item.id).join(SEPARATOR));
  }

  return params.toString();
}
